<template>
  <div>

    <div class="container">
      <div style="margin-bottom: 20px;">订单审批流程</div>
      <el-form
        :rules="rules"
        :inline="true"
        :model="workflowCompany"
        ref="workflowCompany"
      >
        <el-form-item label="审批流程名称：" prop="workflowDefinitionName">
          <el-input
            v-model.trim="workflowCompany.workflowDefinitionName"
            maxlength="20"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <div class="tips">
          <span
            style="
              font-size: 12px;
              float: 20px;
              margin: 0 0 20px 5px;
              display: inline-block;
            "
          >
            说明：审批流程设置支持自定义审批层级节点，在每个节点中，可以设置多个审批人，其中的任何一人审批通过后即可进入下一层级审批节点。
          </span>
        </div>
        <!--表单添加-->
        <el-button type="success" @click="AddListRow('workflowCompany')"
          >添加审批节点</el-button
        >
        <TableList
          style="margin-top: 15px"
          :loading="loading"
          :table-data="tableData"
          :table-label="tableLabel"
        >
          <template v-slot:idx="idx">
            第{{ idx.scope.$index + 1 }}审批节点
          </template>
          <template v-slot:approver="approver">
            <el-col :span="18">
              <div style="display: flex;">
                 <el-tooltip
                class="item"
                effect="light"
                :disabled="disabledFlag(approver.scope.row.approverList)"
                :content="approver.scope.row.approverListStr"
                placement="top"
              >
                <el-input
                  v-model="approver.scope.row.approverListStr"
                  style="width: 84%;"
                  :disabled="true"
                />
              </el-tooltip>
            <!-- </el-col>
            <el-col :span="5"> -->
              <el-button
                size="mini"
                type="primary"
                plain
                icon="el-icon-search"
                :disabled="false"
                @click="
                  editApprover(
                    approver.scope.row,
                    approver.scope.$index
                  )
                "
              />
              </div>
             
            </el-col>
          </template>
          <!-- 操作 -->
          <template v-slot:operation="tData">
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(tData.scope.$index)"
              >删除审批节点</el-button
            >
          </template>
        </TableList>
      </el-form>

      <div style="display: flex;justify-content: space-between;margin-top: 20px;">
        <el-button @click="handleBack()">返回</el-button>
        <el-button type="primary" @click="handleAddPurchase('workflowCompany')"
          >确定修改</el-button
        >
        
      </div>
    </div>
    <AddSupplierDialog 
    :addSupplierVisible.sync="addSupplierVisible"
    @getSelectCompany="getSelectCompany"
    :companyTableList="companyTableList"
    v-if="addSupplierVisible"
    ></AddSupplierDialog>
  </div>
</template>

<script>
import { isSpace } from "../../../utils/validate";
import TableList from "@/modules/projectA/components/common/e-table-list";
import Api from "../../../api/company/index";
import AddSupplierDialog from './addSupplierDialog'
export default {
  name: "orderApproveEdit",
  components: {
    TableList,
    AddSupplierDialog
  },
  data () {
    const validateSpace = (rule, value, callback) => {
      if (isSpace(value)) {
        return callback(new Error("请输入非空格字符！"));
      } else if (!value) {
        return callback(new Error("请输入必填项！"));
      } else {
        return callback();
      }
    };
    return {
      input: "",
      workflowCompany: {
        workflowDefinitionName: "",
        companyName: "",
        WorkflowCompanySku: [],
        workflowDefinitionId: '',
      },
      rules: {
        workflowDefinitionName: [
          {pattern:/^[\w\u4e00-\u9fa5]+$/,message:'输入框类型：汉字，英文，数字，英文下划线。',trigger: "blur",},
          { required: true, trigger: "blur", validator: validateSpace },
        ],
      },
      loading: false,
      tableData: [],
      tableLabel: [
        {
          label: "审批节点",
          param: "orderNo",
          align: "center",
          slot: "idx",
        },
        {
          label: "审批人",
          param: "aftersalesNo",
          align: "center",
          slot: "approver",
        },
        {
          label: "操作",
          fixed: "right",
          align: "center",
          slot: "operation",
        },
      ],
      repetitionFlag: false,
      confirmWorkFlowSkusList:[],
      addSupplierVisible:false,
        companyTableList: [],
        tableInx:''
    };
  },
  created () {
    this.workflowCompany.workflowDefinitionId = this.$route.params.workflowDefinitionId
    this.getApproverList();
    
  },
  mounted() {

  },
  methods: {
    //点击加号添加一行数据
    AddListRow (workflowCompany) {
      this.$refs[workflowCompany].validate((valid) => {
        if (valid) {
          this.tableData.push({});
          
        } else {
          console.log("请输入审批流程名称");
          return false;
        }
      });
    },
    disabledFlag (val) {
      if (val) {
        return false;
      } else {
        return true;
      }
    },
    handleDelete (index) {
      this.$confirm("此操作将永久删除该审批节点, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.tableData.splice(index, 1);
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.companyTableList.length = 0
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    editApprover (row, index) {
      this.tableInx = index
      this.addSupplierVisible = true
      this.companyTableList = row.approverList
      // this.companyTableList.forEach((item) => {
      //   this.$set(items,'memberId',items.approverId)
      //   this.$set(item,'realName',item.approverRealName)
      //   this.$set(item,'mobile',item.approverContact)
      //   this.$set(item,'memberName',item.approverName)
      //   this.$delete(items,'approverId')
      //   this.$delete(item,'approverRealName')
      //   this.$delete(item,'approverContact')
      //   this.$delete(item,'approverName')
      // })
    },
    getApproverList () {
      let params = {
        workflowDefinitionId: this.workflowCompany.workflowDefinitionId,
      };
      
      Api.getWorkflow(params).then((res) => {
        if (res.code == "200") {
          this.tableData = res.data.workflowSkuHeadList

          this.workflowCompany.workflowDefinitionName = res.data.workflowDefinitionName
          this.tableData.forEach((item) => {
            this.$set(item, 'approverList',item.workflowCompanySkuList)
            this.$delete(item, 'workflowCompanySkuList')
            let approverListStr = ''
            
            if(item.approverList.length){
              item.approverList.forEach((items) => {
              approverListStr += items.approverRealName + ','
            })
            approverListStr=approverListStr.substring(0,approverListStr.length-1)
            this.$set(item,'approverListStr',approverListStr)

            item.approverList.forEach((items) => {
              this.$set(items,'memberId',items.approverId)
              this.$set(items,'realName',items.approverRealName)
              this.$set(items,'memberName',items.approverName)
              this.$set(items,'mobile',items.approverContact)
              this.$delete(items,'approverId')
              this.$delete(items,'approverRealName')
              this.$delete(items,'approverName')
              this.$delete(items,'approverContact')

            })
            }
            
          })
         
        }
      });
    },
    handleAddPurchase (workflowCompany) {
      if (this.workflowCompany.workflowDefinitionName == "") {
        this.$refs[workflowCompany].validate((valid) => {
          if (!valid) {
            return false;
          }
        });
        return;
      }
      let dataArr = JSON.parse(this.$getStore("getWorkflowListTableData"));
      dataArr.map((item) => {
        if (
          item.workflowDefinitionName ==
          this.workflowCompany.workflowDefinitionName && Number(this.workflowCompany.workflowDefinitionId) != item.workflowDefinitionId
        ) {
          this.repetitionFlag = true;
        }
      });
      if (this.repetitionFlag) {
        this.repetitionFlag = false;
        return this.$message.warning("已存在同名称审批流程，请重新命名!");
      }
      if (this.tableData.length < 1) {
        return this.$message.warning("请先添加审批节点！");
      }
      let params = {
        workflowDefinitionId:this.workflowCompany.workflowDefinitionId,
        workflowDefinitionName: this.workflowCompany.workflowDefinitionName,
        companyId: "100608",
        workflowSkus: [],
      };

      this.tableData.forEach((param,index) => {
        param.approverList.forEach((skuParam) => {
          let each = {
            approverContact: skuParam.mobile,
            approverName: skuParam.memberName,
            approverRealName: skuParam.realName,
            levelName: "第" + (index+1) + "审批节点",
            level: index + 1,
            companyName: "",
            approverId: skuParam.memberId,
          };
          params.workflowSkus.push(each);
        });
      });
      Api.updateWorkflow(params).then((res) => {
        if (res.code == "200") {
          this.$message({
            type: "success",
            message: "修改成功!",
          });
          this.removeStore();
          this.goToUrl();
        }
      });
    },

    handleBack () {
      this.removeStore();
      this.goToUrl();
    },
    conactData (val, flag) {
      let displayData = [];
      val.forEach((v) => {
        let param = {
          levelName: "",
          approverList: "",
        };

        let t = "";
        //1:从前台编辑点进来 else:从修改审批人过来的
        if (flag == 1) {
          param.levelName = v.levelName;
          v.workflowCompanySkuList.forEach((each) => {
            t += each.approverRealName + ";";
          });
        } else {
          param.levelName = "第" + v.level + "审批节点";
          v.approverList.forEach((each) => {
            t += each.realName + ";";
          });
        }
        param.approverList = t;
        displayData.push(param);
      });
      return displayData;
    },
    goToUrl () {
                this.$store.state.tagsList.map((item, index) => {
                    if (item.fullPath == this.$route.path) {
                        this.$store.state.tagsList.splice(index, 1);
                    }
                })
                this.$router.go(-1);
            },
    removeStore () {
      this.workflowCompany.workflowDefinitionId = ''
        this.workflowCompany.workflowDefinitionName = ''
        this.tableData = []
    },
    getSelectCompany(val){
        this.$set(this.tableData[this.tableInx],'approverList',[...val])
        this.$set(this.tableData[this.tableInx],'auditNodeName',('第' + (this.tableInx + 1) + '审批节点'))
       
        this.companyTableList = [...val];
        
        let tmpArr = ''
        this.tableData[this.tableInx].approverList.forEach((item) => {
          tmpArr += item.realName + ','
        })

        tmpArr=tmpArr.substring(0,tmpArr.length-1)
        this.$set(this.tableData[this.tableInx],'approverListStr',tmpArr)
        },
  },
};
</script>

<style scoped lang="scss">
::v-deep.el-form-item--small .el-form-item__error{
    width: 270px;
  }
</style>
